import { InputAdornment } from "@mui/material";
import { TextFieldElement } from "react-hook-form-mui";
import { useTranslate } from "@refinedev/core";

interface CostPriceUpchargeFieldProps {
    name: string;
}

export const CostPriceUpchargeField = ({ name }: CostPriceUpchargeFieldProps) => {
    const t = useTranslate();

    return (
        <TextFieldElement
            name={name}
            label={t("products.fields.price-upcharge")}
            type="number"
            fullWidth
            placeholder="Enter custom price"
            slotProps={{
                input: {
                    // startAdornment: <InputAdornment position="end">%</InputAdornment>,
                    endAdornment: <InputAdornment position="end">%</InputAdornment>,
                }
            }}
            size="small"
        />
    );
};